import doRequest from "services/helpers";

// ponytail: conserva BaseBE en errores HTTP sin cambiar el cliente HTTP compartido.
const doEmployabilityRequest = async (...args) => {
    const [endpoint, method, data, token, alternativeAPIUrl] = args;
    const [result, err] = await doRequest(
        endpoint,
        method,
        data,
        token,
        alternativeAPIUrl,
        { "X-Empleabilidad-Http-Errors": "true" }
    );
    const errorResponse = err?.response;
    const isBaseBE = errorResponse?.data && typeof errorResponse.data.state === "number";

    return isBaseBE ? [errorResponse, null] : [result, err];
};

export default doEmployabilityRequest;
